import * as React from "react";
import * as _ from "lodash";
import {
    UserTrackableSymptomUpsertRequest,
    TrackableSymptomViewModel
} from "@curefit/gmf-common";
import {default as EditViewCard, EditViewDisplayMode} from "../../components/common/EditViewCard";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils";
import ITrackableSymptomItem from "../../models/ITrackableSymptomItem";
import AppLoader from "../../components/utils/AppLoader";

export interface TrackableSymptomsEditViewContProps {
    patientId: number,
    staticTrackableSymptoms: TrackableSymptomViewModel[],
    trackableSymptoms: UserTrackableSymptomUpsertRequest[],
    displayMode?: EditViewDisplayMode,
    patientTrackableSymptoms: UserTrackableSymptomUpsertRequest[],
    secondaryUserId: string,
    isSelf: boolean,
    appointmentId: number,
    doctorId: number,
    doctorType: string,
}

export interface TrackableSymptomsEditViewContState {
    updatedSymptoms: {item: UserTrackableSymptomUpsertRequest}[],
    savedSymptoms: {item: UserTrackableSymptomUpsertRequest}[],
    isPatientSymptomDataLoaded: LOADING_STATE
}

export default class TrackableSymptomsEditViewCont extends React.Component<TrackableSymptomsEditViewContProps, TrackableSymptomsEditViewContState> {

    constructor(props: TrackableSymptomsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: TrackableSymptomsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getStateFromProps = (props: TrackableSymptomsEditViewContProps) => {
        let currState: TrackableSymptomsEditViewContState = {
            updatedSymptoms: [],
            savedSymptoms: [],
            isPatientSymptomDataLoaded: LOADING_STATE.NOT_INITIALIZED
        };
        if ( _.isNull(props.trackableSymptoms) ) {
            // props.fetchPatientSymptoms(this.props.patientId);
            currState.isPatientSymptomDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedSymptoms = [];
            if (!_.isEmpty(props.patientTrackableSymptoms)) {
                _.map(props.patientTrackableSymptoms, function(symptom) {
                    if (!_.isEmpty(symptom.userTrackableSymptomObj._id)) {
                        let clonePatientSymptoms = Object.assign({}, symptom);
                        currState.savedSymptoms.push({item: clonePatientSymptoms});
                    } else {
                        let clonePatientSymptoms = Object.assign({}, symptom);
                        currState.updatedSymptoms.push({item: clonePatientSymptoms});
                    }
                })
            }
            currState.isPatientSymptomDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    };

    updatePatientSymptom = (updatedSymptoms: {item: UserTrackableSymptomUpsertRequest}[]) => {
        this.setState({updatedSymptoms});
    };

    updateSavedPatientSymptom = (savedSymptoms: {item: UserTrackableSymptomUpsertRequest}[]) => {
        this.setState({savedSymptoms});
    }

    getTrackableSymptomEditViewTemplateProps = () => {
        let patientSymptomsViewProps = {
            trackableSymptoms: this.props.trackableSymptoms
        }
        let patientSymptomsEditorProps = {
            updatedSymptoms: this.state.updatedSymptoms,
            updateSymptoms: this.updatePatientSymptom,
            staticTrackableSymptoms: this.props.staticTrackableSymptoms,
            savedSymptoms: this.state.savedSymptoms,
            updateSavedSymptoms: this.updateSavedPatientSymptom,
            patientId: this.props.patientId
        }
        return {"view": patientSymptomsViewProps, "edit": patientSymptomsEditorProps};
    };

    getSaveObject = () => {
        let {patientId, secondaryUserId, isSelf, appointmentId, doctorId, doctorType} = this.props;
        let savedTrackableSymptomsList: UserTrackableSymptomUpsertRequest[] = [];
        _.map(this.state.updatedSymptoms, (symptomItem: { item: UserTrackableSymptomUpsertRequest }) => {
            let {item} = symptomItem;
            item.userTrackableSymptomId = null;
            item.userTrackableSymptomObj.userId = patientId.toString();
            item.userTrackableSymptomObj.secondaryUserId = secondaryUserId;
            item.userTrackableSymptomObj.isSelf = isSelf;
            item.userTrackableSymptomObj.source.serviceId = "DOCSAPP";
            item.userTrackableSymptomObj.source.serviceRefId = `CONS-${appointmentId}`;
            item.userTrackableSymptomObj.source.userType = "DOCTOR";
            item.userTrackableSymptomObj.source.userRefId = doctorId.toString();
            item.userTrackableSymptomObj.source.sourceFamily = AppUtils.getPlanMetaDoctorType(doctorType);
            item.userTrackableSymptomObj.status = "ACTIVE";
            savedTrackableSymptomsList.push(item);
        });
        _.map(this.state.savedSymptoms, (savedSymptom: { item: UserTrackableSymptomUpsertRequest }) => {
            const {item} = savedSymptom;
            savedTrackableSymptomsList.push(item);
        });
        return savedTrackableSymptomsList;
    };

    isFormDirty = () => {
        let status = false;
        if (!_.isEmpty(this.state.updatedSymptoms)) {
            this.state.updatedSymptoms.map((symptom: { item: UserTrackableSymptomUpsertRequest }) => {
                const {item} = symptom;
                if (_.isEmpty(item.userTrackableSymptomObj.symptomInternalValue)) {
                    status = true;
                }
            });
        }
        return status;
    };

    savePatientSymptoms = () => {}

    cancelActionHandler = () => {}

    render () {
        let isSymptomDataLoaded =  this.state.isPatientSymptomDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className={"trackable-symptoms-edit-view-container"}>
                {
                    isSymptomDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Trackable Symptoms"} templateName={"trackableSymptoms"}
                                  templateProps={this.getTrackableSymptomEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientSymptoms}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode} />
                }
                {
                    !isSymptomDataLoaded &&
                    <AppLoader/>
                }
            </div>
        )
    }
}